import AdventurePage from "./AdventurePage";

export default AdventurePage;
